import { compose } from 'ramda';
import { prop } from 'js/utils/ramda.util';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import React, { useState, useCallback } from 'react';

import { Inputs } from '../Inputs';
import * as helpers from '../../../../helpers';
import { PERIODS } from '../../../../constants';
import { withDynamicReducer, useDynamicReducerSelector } from '../../../../store';

import style from './DateTimePicker.scss';

const DateTimePickerBare = ({ onClose, onSave }) => {
    const [period, setPeriod] = useState(PERIODS.DAILY);
    const data = useDynamicReducerSelector(prop('dateTimePicker'));
    const onChoosePeriod = useCallback(setPeriod, [setPeriod]);
    const translate = useTranslations('playtech.mobile.system.scheduledBreaks.DateTimePicker.');
    const onClick = useCallback(() => {
        onSave(helpers.getValuesToSave({ data, period }));
        onClose();
    }, [data, onSave, onClose, period]);

    return (
        <div className={style.container}>
            <div className={style.periods}>
                <button
                    onClick={() => onChoosePeriod(PERIODS.DAILY)}
                    className={`${style.period} ${period === PERIODS.DAILY ? style.active : ''}`}
                >
                    {translate('daily')}
                </button>
                <button
                    onClick={() => onChoosePeriod(PERIODS.WEEKLY)}
                    className={`${style.period} ${period === PERIODS.WEEKLY ? style.active : ''}`}
                >
                    {translate('weekly')}
                </button>
                <button
                    onClick={() => onChoosePeriod(PERIODS.ONETIME)}
                    className={`${style.period} ${period === PERIODS.ONETIME ? style.active : ''}`}
                >
                    {translate('onetime')}
                </button>
            </div>
            <div className={style.desc}>{translate(`description.${period}`)}</div>
            <div className={style.containerInputs}>
                <Inputs period={period} />
            </div>
            <div className={style.formActions}>
                <Button
                    color='negative'
                    onClick={onClose}
                >
                    {translate('cancel')}
                </Button>
                <Button
                    onClick={onClick}
                >
                    {translate('save')}
                </Button>
            </div>
        </div>
    );
};

export const DateTimePicker = compose(
    withDynamicReducer()
)(DateTimePickerBare);
